import { SocialProfileJsonLd } from 'next-seo'

export default function SocialData() {
  return (
    <SocialProfileJsonLd
      type="Organization"
      name="Ton"
      url="https://www.ton.com.br/"
      sameAs={[
        'https://www.facebook.com/seliganoton',
        'https://twitter.com/seliganoton',
        'https://www.instagram.com/seliganoton',
        'https://www.youtube.com/channel/UCo2OofOde1YZrDGRTqNdBVA/featured?view_as=subscriber'
      ]}
    />
  )
}
